module.exports = __webpack_public_path__ + "static/media/benchi.429c0b4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/benchi.mp4
// module id = 9vOx
// module chunks = 0